import { render, staticRenderFns } from "./SymbolSearchIndex.vue?vue&type=template&id=23580dec&"
import script from "./SymbolSearchIndex.vue?vue&type=script&lang=js&"
export * from "./SymbolSearchIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports